import {
    JustpayNomenclatureEndpoint
} from "@/views/loyalty/shared/endpoint_services/justpay-nomenclature-endpoint-service"

export class JustpayNomenclature {
    constructor () {
        this.justpayNomenclatureEndpoint = new JustpayNomenclatureEndpoint()
    }

    async changeNomenclature (request) {
        await this.justpayNomenclatureEndpoint.changeNomenclature(request)
    }

    async createNomenclature (request) {
        await this.justpayNomenclatureEndpoint.createNomenclature(request)
    }


    async getNomenclaturesByCustomerId (customerId) {
        const nomenclatures = await this.justpayNomenclatureEndpoint.getAllNomenclatures()
        return nomenclatures ? nomenclatures.filter(f => f.client == customerId) : []
    }

    // get nomenclature by filter {field: value}
    async getNomenclatureByFilter (filter) {
        let nomenclature = {}
        nomenclature = await this.justpayNomenclatureEndpoint.getNomenclatureByFilter(filter)
        return nomenclature.data
        // if (nomenclature ? nomenclature.length > 0 : false) {
        //     return nomenclature[0]
        // }
        // return null
    }

    async getNomenclatureList (filter) {
        let nomenclature = {}
        nomenclature = await this.justpayNomenclatureEndpoint.getNomenclatureByFilter(filter)
        return nomenclature
    }


    async getNomenclatures () {
        const nomenclatures = await this.justpayNomenclatureEndpoint.getAllNomenclatures()
        return nomenclatures || []
    }

    async getNomenclatureForHeader (customerId) {
        const nomenclatures = await this.justpayNomenclatureEndpoint.getAllNomenclatures()
        if (nomenclatures) {
            const nomenclatures_filtered = nomenclatures.filter(f => f.client === customerId)
            return nomenclatures_filtered.map(nomenclature => Object.fromEntries(Object.entries(nomenclature).filter(([key]) => ['id', 'code', 'name'].includes(key))))
        } else {
            return [{ id: '', code: '', name: '' }]
        }
    }

    async getNomenclatureForSelection () {
        const nomenclatures = await this.justpayNomenclatureEndpoint.getNomenclatureForSelection()
        return nomenclatures.data.map(nomenclature => {
            return { value: nomenclature.value, text: nomenclature.text }
        })
    }
}
